import { render, staticRenderFns } from "./NeedsAlerts.vue?vue&type=template&id=26535457&scoped=true&"
import script from "./NeedsAlerts.vue?vue&type=script&setup=true&lang=js&"
export * from "./NeedsAlerts.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26535457",
  null
  
)

export default component.exports